const variants = {
  custom: {
    field: {
      _focus: {
        zIndex: 1,
      },
      _placeholder: {
        color: "gray",
      },
      background: "white",
      backgroundColor: "white",
      border: "none",
      borderColor: "none",
      borderRadius: "lg",
      color: "black",
      height: "3rem",
    },
  },
  "outline-accent": {
    field: {
      bg: "white",
      borderColor: "fg-accent",
      borderRadius: "lg",
      borderWidth: "1px",
      color: "fg-main",
      height: "3rem",
      _placeholder: {
        color: "gray.500",
      },
      _hover: {
        borderColor: "fg-accent",
      },
      _focus: {
        borderColor: "fg-accent",
      },
    },
  },
};

export const Select = {
  variants,
  defaultProps: {
    variant: "custom",
  },
};
